/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Hide_NotificationInputs */

const en_admin_dashboard_hide_notification = /** @type {(inputs: Admin_Dashboard_Hide_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide notification`)
};

const de_admin_dashboard_hide_notification = /** @type {(inputs: Admin_Dashboard_Hide_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht verstecken`)
};

const es_admin_dashboard_hide_notification = /** @type {(inputs: Admin_Dashboard_Hide_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar notificación`)
};

const fr_admin_dashboard_hide_notification = /** @type {(inputs: Admin_Dashboard_Hide_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masquer cette alerte`)
};

const nl_admin_dashboard_hide_notification = /** @type {(inputs: Admin_Dashboard_Hide_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melding verbergen`)
};

const it_admin_dashboard_hide_notification = /** @type {(inputs: Admin_Dashboard_Hide_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nascondi notifica`)
};

const pt_br2_admin_dashboard_hide_notification = /** @type {(inputs: Admin_Dashboard_Hide_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar notificação`)
};

const pl_admin_dashboard_hide_notification = /** @type {(inputs: Admin_Dashboard_Hide_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukryj powiadomienie`)
};

const hu_admin_dashboard_hide_notification = /** @type {(inputs: Admin_Dashboard_Hide_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Értesítés elrejtése`)
};

const ro_admin_dashboard_hide_notification = /** @type {(inputs: Admin_Dashboard_Hide_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ascundeti notificarea`)
};

/**
* | output |
* | --- |
* | "Hide notification" |
*
* @param {Admin_Dashboard_Hide_NotificationInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_hide_notification = /** @type {((inputs?: Admin_Dashboard_Hide_NotificationInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Hide_NotificationInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_hide_notification(inputs)
	if (locale === "de") return de_admin_dashboard_hide_notification(inputs)
	if (locale === "es") return es_admin_dashboard_hide_notification(inputs)
	if (locale === "fr") return fr_admin_dashboard_hide_notification(inputs)
	if (locale === "nl") return nl_admin_dashboard_hide_notification(inputs)
	if (locale === "it") return it_admin_dashboard_hide_notification(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_hide_notification(inputs)
	if (locale === "pl") return pl_admin_dashboard_hide_notification(inputs)
	if (locale === "hu") return hu_admin_dashboard_hide_notification(inputs)
	return ro_admin_dashboard_hide_notification(inputs)
});
export { admin_dashboard_hide_notification as "admin.dashboard.hide_notification" }